import { compose, includes, map, pluck, propOr } from 'ramda';
import { Icon, PageTitle } from '@fasstech/middle-design-system';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';

const ElectronicSignatureStarted = ({ getMiddleText, middleFeatures, activeUserRoles }) => {

  const isProspect = includes('PROSPECT', activeUserRoles);

  const emailContentListKey = isProspect
    ? 'PROCESSDEVENTE_SIGNATURE_STARTED_PROSPECT_EMAIL_CONTENT_LIST'
    : 'PROCESSDEVENTE_SIGNATURE_STARTED_EMAIL_CONTENT_LIST';

  const emailContentList = compose(
    pluck('CONTENT'),
    propOr([], emailContentListKey)
  )(middleFeatures);

  return (
    <PageLayout>
      <Icon name={'circleSign'} size={70} />
      <PageTitle>{getMiddleText(
        isProspect
          ? 'PROCESSDEVENTE_SIGNATURE_STARTED_PROSPECT_TITLE'
          : 'PROCESSDEVENTE_SIGNATURE_STARTED_TITLE'
      )}</PageTitle>

      <div className={'mt-8'}>
        <p>{getMiddleText(
          isProspect
            ? 'PROCESSDEVENTE_SIGNATURE_STARTED_PROSPECT_TEXT'
            : 'PROCESSDEVENTE_SIGNATURE_STARTED_TEXT'
        )}</p>

        <ul className="font-bold flex flex-col gap-y-2 list-disc pl-6">
          {map((content) => {
            return <li key={content}>{content}</li>;
          }, emailContentList)}
        </ul>
      </div>
    </PageLayout>
  );
};

export default ElectronicSignatureStarted;
